import CollegeApplicationStatusMenu from 'shared/college-application-status/components/college-application-status-menu';
import {Link} from 'react-router-dom';
import React, {useEffect, ReactElement} from 'react';
import BaseCollegeCard from 'shared/components/college-card/college-card';
import {RecommendedCollege} from 'src/services/RecommendationsService';
import {ApplicationStatusObject, Store} from 'src/types/store';
import useFeatureFlags from 'src/hooks/useFeatureFlags';
import {Track} from 'src/utils/analytics';
import {useSelector} from 'react-redux';
import {isNil} from 'lodash';

export enum SortingFunction {
  AVG_NET_PRICE = 'average-net-price',
  TUITION = 'tuition',
  ACCEPTANCE_RATE = 'acceptance-rate',
  SIX_YEAR_GRADUATION_RATE = 'six-year-graduation-rate',
  FORBES_RANKING = 'forces-ranking',
  US_NEWS_RANKING = 'us-news-ranking',
}

export interface BaseCollegeCardProps {
  condensed?: boolean;
  communityCollegeInfo?: {
    transferSemester: string;
  };
  shortCard?: boolean;
  showBadge?: boolean;
  showDeadline?: boolean;
  showDeadlineYear?: boolean;
  showFollow?: boolean;
  showSortInfo?: boolean;
  showStatus?: boolean;
  sortBy?: SortingFunction;
  wideCard?: boolean;
  // check if required
  openTermNotOfferedModal?: (id: string) => void;
}

export interface CollegeCardProps {
  baseProps?: BaseCollegeCardProps;
  recommendationId: string;
  college: RecommendedCollege;
  collegeApplicationStatus: ApplicationStatusObject;
  events: {
    bucketEventId: string;
    recommendationsShownId: string;
  };
  showApplicationStatusMenu: boolean;
  followCollege: (collegeId: string) => void;
  unfollowCollege: (collegeId: string) => void;
  setApplicationStatus?: (collegeId: string, status: string, segmentId?: string) => void;
}

export const generateUrlWithEvents = (
  slug,
  bucketEventId: string,
  recommendationsShownId: string
): string =>
  `/edu/${slug}?` +
  `bucketEventId=${bucketEventId}` +
  `&recsShownEventId=${recommendationsShownId}`;

export default function CollegeCard(props: CollegeCardProps): ReactElement {
  const college = props.college;
  const campaignId = college.campaignId;
  const collegeHref = generateUrlWithEvents(
    college.slug,
    props.events.bucketEventId,
    props.events.recommendationsShownId
  );
  const flags = useFeatureFlags(['college_application_status']);
  const studentId = useSelector<Store, string>((state) => state.student._id);

  useEffect(() => {
    !isNil(campaignId) &&
      Track.targetMeCampaignViewed(studentId, campaignId, 'sponsored-recommendation');
  }, [campaignId]);

  return (
    <div className="college-search-buckets-card">
      {flags.collegeApplicationStatus && (
        <CollegeApplicationStatusMenu
          collegeApplicationStatus={props.collegeApplicationStatus}
          setCollegeAppStatus={props.setApplicationStatus}
          college={college}
          className="college-search-app-status-section"
          menuButtonColor="primary"
          showStatusContent={false}
          segmentEventLocation="college search dropdown"
        />
      )}
      <Link to={collegeHref}>
        <BaseCollegeCard
          college={college}
          followCollege={props.followCollege}
          unfollowCollege={props.unfollowCollege}
          bucketID={props.recommendationId}
          {...(props.baseProps || {})}
        />
      </Link>
    </div>
  );
}
